export interface LoginResponse {
    message?: string;
    result: string;
}
export interface SearchPaging {
    freeTextSearch?: string
    pageIndex?: number
    pageSize?: number
    courseId?: string
    licenseClassId?: string | null
    partnerId?: string | null
    startDate?: string
    endDate?: string
    isAddCourse?: boolean
    isActive?: boolean
    isEligible? :boolean
    type?: number
}


export interface ApiResponse {
    message: string
    result: any
}

export interface Result {
    items: any[]
    totalRecord: number
}


export interface Course {
    id?: string
    classCode?: string
    name: string
    startDate?: string
    endDate?: string
    openingDate?: string
    closingDate?: string
    registrationDate?: string
    licenseClassId: string
    licenseClassName?: string
    teamCount?: number
    isGraduated?: boolean
    totalStudents?: number
    totalSchedules?: number
    totalTeachers?: number
    totalVehicles?: number
    totalDocuments: number
    totalExams: number
}


export interface Schedule {
    id: string
    courseId: string
    courseName: string
    classCode: string
    teacherId?: string
    teacherName?: string
    vehicleId?: any
    vehiclePlateName?: any
    licenseClassId: string
    licenseClassName: string
    startDate: string
    endDate: string
    notes?: string
    type?: number
    teacherPartnerId?: string | null
    teacherPartnerName?: string
    teacherPartnerDes?: string
    vehiclePartnerId?: string | null
    vehiclePartnerName?: string
    vehiclePartnerDes?: string
}

// Vehicle
export interface Vehicle{
    id?: string
    plateNumber: string
    licenseClassId: string
    licenseClassName?: string
    partnerId? : string | null
    partnerName? : string
    type?: string | null
    note?: string | null
}


// Teacher
export interface Teacher {
    id?: string
    fullName: string
    mobile?: string
    userInternalId?: string
    licenseClassId: string
    licenseClassName: string
    partnerId? : string | null
    partnerName? : string
}

//LicenseClass
export interface LicenseClass {
    id?: string
    name: string
    description: string
    priority: number
    isActive?: boolean
}

//Document
export interface Document {
    id?: string
    name: string
    createById?: string
    createByName?: string
    fileUrl: string
    fileName: string
    type: number
    courseId: string
    courseName?: string
    url?: string
    CreationDate?: Date
    UpdateDate?: Date
    file: File | null
}

export interface Exam {
    id?: string
    courseId: string
    courseName?: string
    name?: string
    startDate: Date
    endDate: Date
    vehicleId?: string
    vehiclePlateNumber?: string
    type?: number
    count?: number
    notes?: string
}

export interface Subject {
    id: string;
    name: string;
    code: string;
    type: number;
}

export enum ScheduleType {
    LyThuyet = 1,
    ThucHanhTrongHinh = 2,
    ThucHanhTrenDuong = 3,
    KiemTra = 4,
    NghiDuPhong = 5,
    On = 6
}

export const ScheduleTypeOptions = [
    { value: ScheduleType.LyThuyet, label: "Lý thuyết" },
    { value: ScheduleType.ThucHanhTrongHinh, label: "Thực hành trong hình" },
    { value: ScheduleType.ThucHanhTrenDuong, label: "Thực hành trên đường" },
    { value: ScheduleType.On, label: "Ôn" },
    { value: ScheduleType.KiemTra, label: "Kiểm tra" },
    { value: ScheduleType.NghiDuPhong, label: "Nghỉ dự phòng" }
]

export interface DocumentItem {
    id: string;
    name: string;
    url: string;
    isFolder: boolean;
    creationDate: string;
    updateDate: string;
}

export interface Setting {
    id: string;
    key: string;
    value: string;
}

export interface CustomDatePickerProps {
    selected: string | undefined;
    onChange: (date: Date | null) => void
    placeholder?: string
    minDate?: Date
    maxDate?: Date
    disabled?: boolean
    className?: string
    id?: string
    name?: string
    required?: boolean
}

export interface Log {
    id: string
    recordId: string
    action: string
    detail: string
    userId: string
    fullName: string
    creationDate: string
}

export interface TeachingAndVehicle {
    courseId: string
    courseName: string
    courseCode: string
    licenseClassName: string
    teachers: Teacher[]
    vehicles: Vehicle[]
}
